import { ICardspressItem, IpaginatedCardspress } from '../models'

export enum CardspressActionTypes {
  SEARCH_CARDSPRESS = 'cardspress/search',
  SEARCHING_CARDSPRESS = 'cardspress/searching',
  FOUND_CARDSPRESS = 'cardspress/found',
  SEARCHING_CARDSPRESS_FAILED = 'cardspress/searching_failed',

  LOAD_CARDSPRESS = 'cardspress/load',
  LOADING_CARDSPRESS = 'cardspress/loading',
  LOADED_CARDSPRESS = 'cardspress/loaded',
  LOADING_CARDSPRESS_FAILED = 'cardspress/loading_failed',

  ADD_CARDSPRESS = 'cardspress/add',
  ADDING_CARDSPRESS = 'cardspress/adding',
  ADDED_CARDSPRESS = 'cardspress/added',
  ADDING_CARDSPRESS_FAILED = 'cardspress/adding_failed',

  REMOVE_CARDPRESS = 'cardspress/remove',
  REMOVING_CARDPRESS = 'cardspress/removing',
  REMOVED_CARDPRESS = 'cardspress/removed',
  REMOVING_CARDPRESS_FAILED = 'cardspress/removing_failed',

  SOFT_REMOVE_CARDSPRESS = 'cardspress/soft_remove',
  SOFT_REMOVING_CARDSPRESS = 'cardspress/soft_removing',
  SOFT_REMOVED_CARDSPRESS = 'cardspress/soft_removed',
  SOFT_REMOVING_CARDSPRESS_FAILED = 'cardspress/soft_removing_failed',

  EDIT_CARDSPRESS = 'cardspress/edit',
  EDITING_CARDSPRESS = 'cardspress/editing',
  EDITED_CARDSPRESS = 'cardspress/edited',
  EDITING_CARDSPRESS_FAILED = 'cardspress/editing_failed',

  VIEW_CARDSPRESS = 'cardspress/view',
  VIEWING_CARDSPRESS = 'cardspress/viewing',
  VIEWED_CARDSPRESS = 'cardspress/viewed',
  VIEWING_CARDSPRESS_FAILED = 'cardspress/viewing_failed',
}

export function searchCardspress(searchOptions: TSearchOptions | string, keep?: boolean): ISearchCardspressAction {
  return {
    type: CardspressActionTypes.SEARCH_CARDSPRESS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingCardspress(): ISearchingCardspressAction {
  return {
    type: CardspressActionTypes.SEARCHING_CARDSPRESS,
  }
}

export function foundCardspress(cardspress: IpaginatedCardspress, keep?: boolean): IFoundCardspressAction {
  return {
    type: CardspressActionTypes.FOUND_CARDSPRESS,
    keep: keep,
    payload: {
      cardspress,
    },
  }
}

export function searchingCardspressFailed(): ISearchingCardspressFailedAction {
  return {
    type: CardspressActionTypes.SEARCHING_CARDSPRESS_FAILED,
  }
}

export function loadCardspress(loadOptions: TSearchOptions): ILoadCardspressAction {
  return {
    type: CardspressActionTypes.LOAD_CARDSPRESS,
    loadOptions: loadOptions,
  }
}

export function loadingCardspress(): ILoadingCardspressAction {
  return {
    type: CardspressActionTypes.LOADING_CARDSPRESS,
  }
}

export function loadedCardspress(cardspress: IpaginatedCardspress): ILoadedCardspressAction {
  return {
    type: CardspressActionTypes.LOADED_CARDSPRESS,
    payload: {
      cardspress,
    },
  }
}

export function loadingCardspressFailed(): ILoadingCardspressFailedAction {
  return {
    type: CardspressActionTypes.LOADING_CARDSPRESS_FAILED,
  }
}

export function addCardspress(cardpress: ICardspressItem): IAddCardspressAction {
  return {
    type: CardspressActionTypes.ADD_CARDSPRESS,
    payload: cardpress,
  }
}

export function addingCardspress(): IAddingCardspressAction {
  return {
    type: CardspressActionTypes.ADDING_CARDSPRESS,
  }
}

export function addedCardspress(cardspress: IpaginatedCardspress): IAddedCardspressAction {
  return {
    type: CardspressActionTypes.ADDED_CARDSPRESS,
    payload: {
      cardspress,
    },
  }
}

export function addingCardspressFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingCardspressFailedAction {
  return {
    type: CardspressActionTypes.ADDING_CARDSPRESS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeCardpress(cardpress: ICardspressItem): IRemoveCardpressAction {
  return {
    type: CardspressActionTypes.REMOVE_CARDPRESS,
    payload: cardpress,
  }
}

export function removingCardpress(): IRemovingCardpressAction {
  return {
    type: CardspressActionTypes.REMOVING_CARDPRESS,
  }
}

export function removedCardpress(): IRemovedCardpressAction {
  return {
    type: CardspressActionTypes.REMOVED_CARDPRESS,
  }
}

export function removingCardpressFailed(): IRemovingCardpressFailedAction {
  return {
    type: CardspressActionTypes.REMOVING_CARDPRESS_FAILED,
  }
}

export function softRemoveCardspress(cardpress: ICardspressItem): ISoftRemoveCardspressAction {
  return {
    type: CardspressActionTypes.SOFT_REMOVE_CARDSPRESS,
    payload: cardpress,
  }
}

export function softRemovingCardspress(): ISoftRemovingCardspressAction {
  return {
    type: CardspressActionTypes.SOFT_REMOVING_CARDSPRESS,
  }
}

export function softRemovedCardspress(cardpress: ICardspressItem): ISoftRemovedCardspressAction {
  return {
    type: CardspressActionTypes.SOFT_REMOVED_CARDSPRESS,
    payload: cardpress,
  }
}

export function softRemovingCardspressFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingCardspressFailedAction {
  return {
    type: CardspressActionTypes.SOFT_REMOVING_CARDSPRESS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editCardspress(cardpress: ICardspressItem): IEditCardspressAction {
  return {
    type: CardspressActionTypes.EDIT_CARDSPRESS,
    payload: cardpress,
  }
}

export function editingCardspress(): IEditingCardspressAction {
  return {
    type: CardspressActionTypes.EDITING_CARDSPRESS,
  }
}

export function editedCardspress(cardspress: ICardspressItem): IEditedCardspressAction {
  return {
    type: CardspressActionTypes.EDITED_CARDSPRESS,
    payload: cardspress,
  }
}

export function editingCardspressFailed(errData: { data: { message: string; field?: string }; status: number }): IEditingCardspressFailedAction {
  return {
    type: CardspressActionTypes.EDITING_CARDSPRESS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewCardspress(cardpress: ICardspressItem): IViewCardspressAction {
  return {
    type: CardspressActionTypes.VIEW_CARDSPRESS,
    payload: cardpress,
  }
}

export function viewingCardspress(): IViewingCardspressAction {
  return {
    type: CardspressActionTypes.VIEWING_CARDSPRESS,
  }
}

export function viewedCardspress(cardspress: ICardspressItem): IViewedCardspressAction {
  return {
    type: CardspressActionTypes.VIEWED_CARDSPRESS,
    payload: cardspress,
  }
}

export function viewingCardspressFailed(): IViewingCardspressFailedAction {
  return {
    type: CardspressActionTypes.VIEWING_CARDSPRESS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchCardspressAction {
  type: CardspressActionTypes.SEARCH_CARDSPRESS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingCardspressAction {
  type: CardspressActionTypes.SEARCHING_CARDSPRESS
}

export interface IFoundCardspressAction {
  type: CardspressActionTypes.FOUND_CARDSPRESS
  keep?: boolean
  payload: {
    cardspress: IpaginatedCardspress
  }
}

export interface ISearchingCardspressFailedAction {
  type: CardspressActionTypes.SEARCHING_CARDSPRESS_FAILED
}

export interface ILoadCardspressAction {
  type: CardspressActionTypes.LOAD_CARDSPRESS
  loadOptions: TSearchOptions
}

export interface ILoadingCardspressAction {
  type: CardspressActionTypes.LOADING_CARDSPRESS
}

export interface ILoadedCardspressAction {
  type: CardspressActionTypes.LOADED_CARDSPRESS
  payload: {
    cardspress: IpaginatedCardspress
  }
}

export interface ILoadingCardspressFailedAction {
  type: CardspressActionTypes.LOADING_CARDSPRESS_FAILED
}

export interface IAddCardspressAction {
  type: CardspressActionTypes.ADD_CARDSPRESS
  payload: ICardspressItem
}

export interface IAddingCardspressAction {
  type: CardspressActionTypes.ADDING_CARDSPRESS
}

export interface IAddedCardspressAction {
  type: CardspressActionTypes.ADDED_CARDSPRESS
  payload: {
    cardspress: IpaginatedCardspress
  }
}

export interface IAddingCardspressFailedAction {
  type: CardspressActionTypes.ADDING_CARDSPRESS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveCardpressAction {
  type: CardspressActionTypes.REMOVE_CARDPRESS
  payload: ICardspressItem
}

export interface IRemovingCardpressAction {
  type: CardspressActionTypes.REMOVING_CARDPRESS
}

export interface IRemovedCardpressAction {
  type: CardspressActionTypes.REMOVED_CARDPRESS
}

export interface IRemovingCardpressFailedAction {
  type: CardspressActionTypes.REMOVING_CARDPRESS_FAILED
}

export interface ISoftRemoveCardspressAction {
  type: CardspressActionTypes.SOFT_REMOVE_CARDSPRESS
  payload: ICardspressItem
}

export interface ISoftRemovingCardspressAction {
  type: CardspressActionTypes.SOFT_REMOVING_CARDSPRESS
}

export interface ISoftRemovedCardspressAction {
  type: CardspressActionTypes.SOFT_REMOVED_CARDSPRESS
  payload: ICardspressItem
}

export interface ISoftRemovingCardspressFailedAction {
  type: CardspressActionTypes.SOFT_REMOVING_CARDSPRESS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditCardspressAction {
  type: CardspressActionTypes.EDIT_CARDSPRESS
  payload: ICardspressItem
}

export interface IEditingCardspressAction {
  type: CardspressActionTypes.EDITING_CARDSPRESS
}

export interface IEditedCardspressAction {
  type: CardspressActionTypes.EDITED_CARDSPRESS
  payload: ICardspressItem
}

export interface IEditingCardspressFailedAction {
  type: CardspressActionTypes.EDITING_CARDSPRESS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewCardspressAction {
  type: CardspressActionTypes.VIEW_CARDSPRESS
  payload: ICardspressItem
}

export interface IViewingCardspressAction {
  type: CardspressActionTypes.VIEWING_CARDSPRESS
}

export interface IViewedCardspressAction {
  type: CardspressActionTypes.VIEWED_CARDSPRESS
  payload: ICardspressItem
}

export interface IViewingCardspressFailedAction {
  type: CardspressActionTypes.VIEWING_CARDSPRESS_FAILED
}

export type CardspressAction =
  | ISearchCardspressAction
  | ISearchingCardspressAction
  | IFoundCardspressAction
  | ISearchingCardspressFailedAction
  | ILoadCardspressAction
  | ILoadingCardspressAction
  | ILoadedCardspressAction
  | ILoadingCardspressFailedAction
  | IAddCardspressAction
  | IAddingCardspressAction
  | IAddedCardspressAction
  | IAddingCardspressFailedAction
  | IRemoveCardpressAction
  | IRemovingCardpressAction
  | IRemovedCardpressAction
  | IRemovingCardpressFailedAction
  | ISoftRemoveCardspressAction
  | ISoftRemovingCardspressAction
  | ISoftRemovedCardspressAction
  | ISoftRemovingCardspressFailedAction
  | IEditCardspressAction
  | IEditingCardspressAction
  | IEditedCardspressAction
  | IEditingCardspressFailedAction
  | IViewCardspressAction
  | IViewingCardspressAction
  | IViewedCardspressAction
  | IViewingCardspressFailedAction
